import DownIcon from './down.svg';
import UpIcon from './up.svg';

type TProps = {
  reverse: boolean;
};

export const SortingDirection = ({ reverse }: TProps) => {
  return (
    <span className="inline-flex h-[15px] items-center py-0 pl-1.5 pr-0 align-middle [&_svg]:block [&_svg]:h-2 [&_svg]:w-2">
      {reverse ? <DownIcon /> : <UpIcon />}
    </span>
  );
};
